import React from 'react';
import sButtons from "../../../assets/styles/buttons.module.css";
import {useNavigate} from "react-router-dom";

interface BackButtonProps {
    className?: string;
}

export const BackButton: React.FC<BackButtonProps> = ({className}) => {
    const navigate = useNavigate();
    const goBack = () => {
        navigate(-1);
    }
    const buttonClassName = className 
        ? `${sButtons.backBtn} ${className}`
        : sButtons.backBtn;
        
    return (
        <button className={buttonClassName} onClick={goBack}>
            Назад
        </button>
    )
};